import { render, staticRenderFns } from "./asset-image.component.vue?vue&type=template&id=3f616129"
import script from "./asset-image.component.vue?vue&type=script&lang=js"
export * from "./asset-image.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports